import api from '../api';

/** Release the search snapshot once the user leaves its filters or page. */
export async function closeSearchSession(cursor: string): Promise<void> {
  await api.post('/lots/search/close', { cursor }, { timeout: 5000 });
}
